import { Link } from 'react-router-dom';
import { LoaderLogo } from '../assets/svgImages';
import { BrandingLoaderProps } from '../interface/interface';
import Loading from './Loading';

export const BrandingLoader = ({ loaderText }: BrandingLoaderProps) => {
  return (
    <div className="bg-secondary-pink-100 w-full h-screen fixed top-0 left-0">
      <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center flex flex-col items-center">
        {process.env.VITE_THEME_TOGGLE === 'MedReleaf' ? (
          <Loading />
        ) : (
          <LoaderLogo />
        )}
        <p className="text-sm font-semibold text-primary-blue-500 mt-3">
          {loaderText}
        </p>
        <Link
          to={'/profile'}
          className="text-center text-primary-blue-500 mt-3 text-sm border-b border-primary-blue-500"
        >
          Back to profile
        </Link>
      </div>
    </div>
  );
};
